import React from 'react';
import { Skeleton } from '../ui/Skeleton';

export default function SkeletonFormAnalytics() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-pulse">
      {/* Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <Skeleton className="h-7 w-48 mb-2" rounded="rounded" />
          <Skeleton className="h-4 w-32" rounded="rounded" />
        </div>
        <Skeleton className="h-9 w-36" rounded="rounded-lg" />
      </div>

      {/* Stats grid */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 p-5">
            <Skeleton className="h-3 w-20 mb-2" rounded="rounded" />
            <Skeleton className="h-7 w-16 mb-1" rounded="rounded" />
            <Skeleton className="h-3 w-12" rounded="rounded" />
          </div>
        ))}
      </div>

      {/* Table */}
      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100 dark:border-gray-700">
          <Skeleton className="h-5 w-32" rounded="rounded" />
        </div>
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="grid grid-cols-4 gap-4 px-6 py-3 border-b border-gray-50 dark:border-gray-700/50">
            <Skeleton className="h-4 w-24" rounded="rounded" />
            <Skeleton className="h-4 w-16" rounded="rounded" />
            <Skeleton className="h-4 w-20" rounded="rounded" />
            <Skeleton className="h-4 w-12" rounded="rounded" />
          </div>
        ))}
      </div>
    </div>
  );
}
